import { render, staticRenderFns } from "./SidePanelFinish.vue?vue&type=template&id=3b0a4b56&scoped=true"
import script from "./SidePanelFinish.vue?vue&type=script&lang=ts"
export * from "./SidePanelFinish.vue?vue&type=script&lang=ts"
import style0 from "./SidePanelFinish.vue?vue&type=style&index=0&id=3b0a4b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0a4b56",
  null
  
)

export default component.exports